// Reads the CSRF cookie (deliberately non-httpOnly — see backend/src/middleware/csrf.js)
// so it can be echoed back as the X-CSRF-Token header on state-changing requests, per the
// double-submit cookie pattern. Used by the global axios interceptor and by every raw
// fetch() call site that bypasses it.
export function getCsrfToken(): string | null {
  const match = document.cookie.match(/(?:^|; )csrf_token=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

// Convenience for raw fetch() call sites: spreads into the headers object, empty if no
// CSRF cookie is present yet (e.g. before first login).
export function csrfHeader(): Record<string, string> {
  const token = getCsrfToken();
  return token ? { 'X-CSRF-Token': token } : {};
}
